import localforage from 'localforage/dist/localforage.nopromises';

// eslint-disable-next-line prefer-destructuring
export const localStorage = window.localStorage;

export const localForage = localforage; // https://localforage.github.io/

// eslint-disable-next-line angular/module-getter
localForage.config({
  name: 'RxDBStorage',
  version: 2.0,
});
